import React from 'react';

import { useTranslation } from 'react-i18next';
import { CoreLink, RecursiveMenu } from '@uncinc/react-drupal-core';

import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';
import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { NEWSLETTER_URL_ORGS, NEWSLETTER_URL_PRIVATE, SUPPORT_OF_URL } from '../../../config/constants';

import { Image, Divider, ButtonWrapper } from '../../../components';
import FooterSocialLinks from '../../Menus/FooterSocialLinks';

import '../style.scss';
import './style.scss';

const FooterMenuItemWithImage = ({ item }: MenuItemLinkElementProps) => {
  const { link } = item;

  const title = link.title ?? 'Untitled';

  return (
    <div>
      <div>{title}</div>
      {item.subtree && item.subtree.map((subItem, index) => {
        // @ts-expect-error MenuItemLinkElementProps options attributes is missing image
        const image = subItem.link.options?.image?.styles.partner_slider_teaser ?? '';
        const subTitle = subItem.link.title ?? 'Untitled';

        return image ? (
          <CoreLink href={subItem.link.url}>
            <Image
              src={image}
              alt={subTitle}
            />
          </CoreLink>
        ) : null;
      })}
    </div>
  );
};

// @ts-expect-error
const MenuItemLinkOverwrite = ({ children, ...props }) => {
  const { t } = useTranslation();
  if (props.data === 'Nieuwsbrief') {
    return (
      <div className="Newsletter_block">
        <h4>{t('newsletter_title')}</h4>
        <p>{t('subscribe_text')}</p>
        <ButtonWrapper
          type="primary"
          href={NEWSLETTER_URL_PRIVATE}
        >
          {t('subscribe')}
        </ButtonWrapper>
        <ButtonWrapper
          type="secondary"
          href={NEWSLETTER_URL_ORGS}
        >
          {t('for_organisations')}
        </ButtonWrapper>
      </div>
    );
  }

  return (
    <li {...props}>{children}</li>
  );
};

const GenericFooter = () => {
  const { t } = useTranslation();
  return (
    <div id="Footer" className="Footer">
      <Container>
        <div>
          <RecursiveMenu
            menuId="footer"
            // @ts-expect-error
            MenuItemLink={MenuItemLinkOverwrite}
          />
        </div>
        <div className="Footer__bottom-row">
          <div className="row">
            <div className="col-12 col-sm-6">
              <FooterSocialLinks />
            </div>
            <div className="col-12 col-sm-6">
              <h4>{t('support_of')}</h4>
              <ButtonWrapper
                type="primary"
                href={SUPPORT_OF_URL}
              >
                {t('support_us')}
              </ButtonWrapper>
            </div>
          </div>
        </div>
      </Container>
      <Divider className="Footer__divider" />
      <Container>
        <div>
          <RecursiveMenu MenuItemLinkElement={FooterMenuItemWithImage} menuId="footer-supported-by" />
        </div>
      </Container>
      <Divider className="Footer__divider" />
      <Container>
        <div className="Footer__copyright">
          <div className="Footer__copyright__title">Copyright © {new Date().getFullYear()} Oranje Fonds</div>
          <RecursiveMenu menuId="footer-copyright" />
        </div>

      </Container>
    </div>
  );
};

export default GenericFooter;
